module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"default-origin-country":"Default Origin Country","default-commodity-code":"Default Commodity Code","vat-number":"VAT Number","eori-number":"EORI Number","export-reason":"Export Reason","vat-status":"VAT Status"}}')
  delete Component.options._Ctor
}
